import { httpService } from 'src/services/fetch/HttpService';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import {
  HTTP_HEADER_KEYS,
  HTTP_METHODS
} from 'src/utils/constants/HttpMethodsConstants';
import { USER_TOKEN } from 'src/utils/constants/localStorageConstants';

export const gwapigetWithUserToken = async (url: string) => {
  const userToken = getLocalStorage(USER_TOKEN);
  const headers = [
    HTTP_HEADER_KEYS.X_USER_TYPE,
    HTTP_HEADER_KEYS.X_Z5_APP_VERSION,
    HTTP_HEADER_KEYS.X_Z5_APP_PLATFORM,
    HTTP_HEADER_KEYS.X_ACCESS_TOKEN
  ];
  if (userToken) {
    headers.push(HTTP_HEADER_KEYS.AUTHORIZATION);
  } else {
    headers.push(HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN);
  }
  return httpService.fetchApiData({ url, type: HTTP_METHODS.GET, headers });
};
